module.exports = __webpack_public_path__ + "media/images/menu/europa-320ebb44834240172111d40e77241435.jpg";